import React, { useEffect } from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import DocumentItem from "../../../../Components/Masters/DocumentItem";
import { getMonthName } from "../../../../utils/getMonthName";
import { truncateNumber } from "../../../../utils/common";
function ViewConsumptionFacility(props) {
  useEffect(() => {
    console.log(props.selectedData, props.selectedData?.model, "selectedData");
  }, [props]);

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setView(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          Consumption by Facility Details
        </Typography>
        <Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Date
            </Typography>

            <p>
              {new Date(props.selectedData?.createdAt).toLocaleDateString(
                "en-GB",
                { day: "2-digit", month: "2-digit", year: "numeric" }
              ) ?? ""}
            </p>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Consumption Month
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.selectedData?.vendor?.VendorLegalFullName ?? ""} */}
              {getMonthName(props.selectedData?.consumptionPeriod?.month) +
                " " +
                props.selectedData?.consumptionPeriod?.year}
            </p>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Vendor Name
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.selectedData?.vendor?.VendorLegalFullName ?? ""}
            </p>
          </Box>
        </Box>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Previous Meter Reading
          </Typography>
          <p>
            {" "}
            {truncateNumber(props.selectedData?.previousMeterReading) ?? ""}
          </p>
        </Box>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Current Meter Reading
          </Typography>
          <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
            {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
            {truncateNumber(props.selectedData?.currentMeterReading) ?? ""}
          </p>
        </Box>

        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Multiplication Factor
          </Typography>
          <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
            {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
            {props.selectedData?.multiplicationFactor ?? ""}
          </p>
        </Box>

        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Units Consumed(KWH)
          </Typography>
          <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
            {props.selectedData?.unitOfConsumption === ""
              ? "-"
              : truncateNumber(props.selectedData?.unitOfConsumption)}
          </p>
        </Box>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", marginBottom: "1rem" }}
          >
            Equipment (optional)
          </Typography>
          <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
            {/* {props.selectedData?.equipment?.equipment ?? ""} */}
            {props.selectedData?.equipment?.length > 0 ? (
              props.selectedData.equipment.map((eq, index) => (
                <p style={{ marginTop: "-1rem" }} key={index}>
                  {eq.equipment || eq._id}
                </p>
              ))
            ) : (
              <p style={{ marginTop: "-1rem" }}>-</p>
            )}
          </p>
        </Box>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          Reason for Deviation (optional)
        </Typography>
        <p>{props.selectedData?.reasonForDeviation ?? "-"}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          Remark (optional)
        </Typography>
        <p>{props.selectedData?.remarks ?? "-"}</p>

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents (optional)
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ width: "100%" }}
          >
            {/* {data && data.documents.length > 0 ? ( */}
            {props.selectedData && props.selectedData.documents.length > 0 ? (
              <>
                {/* Render Images First */}
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {props.selectedData.documents
                    .filter((url) =>
                      ["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`image-${index}`} url={url} />
                    ))}
                </Box>

                {/* Render Other Documents */}
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {props.selectedData.documents
                    .filter(
                      (url) =>
                        !["png", "jpg", "jpeg"].includes(
                          url.split(".").pop().toLowerCase()
                        )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`file-${index}`} url={url} />
                    ))}
                </Box>
              </>
            ) : (
              <p>-</p>
            )}
          </Box>
        </Box>

        {!props?.companyAdmin && (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={() =>
              props.selectedData?._id !== null &&
              props.handleEdit(props.selectedData)
            }
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.view}
        onClose={() => props.setView(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default ViewConsumptionFacility;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
